import { render } from "./sessionReallocationDetail.vue?vue&type=template&id=62d4fba0&scoped=true"
import script from "./sessionReallocationDetail.vue?vue&type=script&lang=js"
export * from "./sessionReallocationDetail.vue?vue&type=script&lang=js"

import "./sessionReallocationDetail.vue?vue&type=style&index=0&id=62d4fba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d4fba0"]])

export default __exports__